import {useMemo} from "react";

import {CollapsiblePanel} from "@/components/collapsiblePanel/CollapsiblePanel.tsx";
import {Dot} from "@/components/dot/Dot.tsx";
import {AnalyzerPhase, SSEEventType} from "@/pages/analyzer/Analyzer.types.ts";
import {hasCheckSelectionEvent} from "@/pages/analyzer/Analyzer.utils.ts";
import {useAnalyzerContext} from "@/pages/analyzer/hooks/AnalyzerContext.tsx";

import styles from "./AnalyzerChatHeader.module.scss";

export const AnalyzerChatHeader = () => {
  const {phase, analyzedDomain, events} = useAnalyzerContext();
  const streamingStatus = useMemo(() => {
    if (hasCheckSelectionEvent(events)) {
      return "Updating Checks";
    }
    if (events.some(({type}) => type === SSEEventType.ANSWER)) {
      return "Proposing Checks";
    }
    return `Analyzing ${analyzedDomain}`;
  }, [events, analyzedDomain]);
  const statusText = {
    [AnalyzerPhase.IDLE]: "",
    [AnalyzerPhase.STREAMING]: streamingStatus,
    [AnalyzerPhase.INTERVIEW]: "Awaiting your response",
    [AnalyzerPhase.CHECK_SELECTION]: "Results ready",
    [AnalyzerPhase.DONE]: "Results ready",
    [AnalyzerPhase.ERROR]: "Analysis failed",
    [AnalyzerPhase.ABORTED]: "Analysis stopped",
  }[phase];

  return (
    <div className={styles.header}>
      <div className={styles.titles}>
        <div className={styles.name}>Uptime Assistant</div>
        <div className={styles.status}>
          <Dot variant="gradientGreen" animation={phase === AnalyzerPhase.STREAMING ? "pulse" : undefined} />
          {statusText}
        </div>
      </div>
      <CollapsiblePanel.ToggleButton label="Collapse chat" />
    </div>
  );
};
